/** 手机使用要求：记录按字段阅读，金额/薪资对比保留横向表；弹窗表单可换行、主要操作便于触控。只调整显示，不改变数据、权限及审批规则。 */
import React, { useRef, useState } from "react";
import { CheckCircle2 } from "lucide-react";

/* 左滑（触摸 / 鼠标拖拽）露出「已核对」→ 松手弹轻量确认（可备注）→ onReview(note)。children 为函数，收到 openConfirm 供桌面按钮复用。 */
export function SwipeReviewCard({ children, enabled, onReview, zh, testId }) {
  const [dx, setDx] = useState(0);
  const [confirm, setConfirm] = useState(false);
  const [note, setNote] = useState("");
  const [busy, setBusy] = useState(false);
  const start = useRef(null);
  const moved = useRef(false);
  const onDown = (e) => { if (!enabled || e.button > 0) return; start.current = e.clientX; moved.current = false; };
  const onMove = (e) => {
    if (start.current === null) return;
    const raw = e.clientX - start.current;
    if (Math.abs(raw) > 8) moved.current = true;
    setDx(Math.min(0, Math.max(-110, raw)));
  };
  const onUp = () => { if (start.current === null) return; if (dx <= -60) setConfirm(true); setDx(0); start.current = null; };
  const onClickCapture = (e) => { if (moved.current) { e.stopPropagation(); e.preventDefault(); moved.current = false; } };
  const submit = async () => { setBusy(true); try { await onReview(note.trim()); setConfirm(false); setNote(""); } finally { setBusy(false); } };
  return (
    <div data-testid={testId} data-swipe-enabled={enabled ? 1 : 0}>
      <div className="relative">
        {enabled && dx < 0 && <div className="absolute inset-y-0 right-0 w-[110px] rounded-xl bg-emerald-600 text-white flex items-center justify-center gap-1 text-xs font-semibold select-none" data-testid={`${testId}-action`}><CheckCircle2 className="h-4 w-4" />{zh ? "已核对" : "Reviewed"}</div>}
        <div className="relative" style={{ transform: `translateX(${dx}px)`, transition: start.current === null ? "transform .18s ease-out" : "none", touchAction: "pan-y", userSelect: enabled ? "none" : undefined }}
          onPointerDown={onDown} onPointerMove={onMove} onPointerUp={onUp} onPointerCancel={onUp} onPointerLeave={() => start.current !== null && onUp()} onClickCapture={onClickCapture}>
          {children(() => setConfirm(true))}
        </div>
      </div>
      {confirm && (
        <div className="mt-1 rounded-xl border border-emerald-300 bg-emerald-50 p-2.5 text-xs flex flex-wrap items-center gap-1.5" data-testid={`${testId}-confirm`}>
          <span className="font-semibold text-emerald-900">{zh ? "标记 QB 差异已核对？" : "Mark QB differences reviewed?"}</span>
          <input className="flex-1 min-w-[140px] rounded-md border border-emerald-300 bg-white px-2 py-1.5" placeholder={zh ? "备注（可选）" : "Note (optional)"} value={note} onChange={(e) => setNote(e.target.value)} data-testid={`${testId}-note`} />
          <button type="button" disabled={busy} className="min-h-11 min-w-11 md:min-h-0 md:min-w-0 rounded-md px-3 py-1.5 bg-emerald-600 text-white disabled:opacity-50" data-testid={`${testId}-ok`} onClick={submit}>{zh ? "确认" : "Confirm"}</button>
          <button type="button" className="min-h-11 min-w-11 md:min-h-0 md:min-w-0 rounded-md px-2.5 py-1.5 text-slate-600" data-testid={`${testId}-cancel`} onClick={() => { setConfirm(false); setNote(""); }}>{zh ? "取消" : "Cancel"}</button>
        </div>
      )}
    </div>
  );
}
